<template>
    <div>
        <div class="search-box-1">
            <!-- <p>系别：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.departmentCode">
                <a-select-option v-for="(item,index) in xbArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select> -->
            <p>学年：</p>
            <a-date-picker
                class="input-box"
                mode="year"
                format='YYYY'
                v-model="year" 
                :open='yearShowOne' 
                @openChange="openChangeOne"
                @panelChange="panelChangeOne">
                <a-input  v-model="searchFrom.schoolYear" />
            </a-date-picker>
            <p>学期：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.semester" >
                <!-- For years before 2025, keep all options -->
                <template v-if="year < '2025'">
                    <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                    <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                </template>
                <!-- For 2025 and later, only show two semesters -->
                <template v-else>
                    <a-select-option :value="year+'A'">秋季学期</a-select-option>
                    <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                </template>
            </a-select>
            <p>课程名称：</p>
            <a-input class="input-box" v-model="searchFrom.courseName" />
            <p>教师名字：</p>
            <a-input class="input-box" v-model="searchFrom.teacherName" />
            

        </div>
        <div class="search-box">
            <p>系别：</p>
            <a-select 
                        class="input-box" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="searchFrom.departmentCode"
                        option-label-prop="label"
                        >
                        <a-select-option v-for="(item,index) in departmentTree" :key="index" :value="item.dataCode" :label="item.dataName">{{item.dataName}}</a-select-option>
                    </a-select>
            <p>职称：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.technicalTitleCode">
                <a-select-option v-for="(item,index) in zcArr" :key="index" :value="item.dataCode">{{item.dataName}}</a-select-option>
            </a-select>
            <p>修改答疑：</p>
            <a-select class="input-box" allowClear v-model="searchFrom.answerUpdateFlag">
                <a-select-option value=true>是</a-select-option>
                <a-select-option value=false>否</a-select-option>
            </a-select>
            <a-button type="primary" icon="search" @click="searchList">搜索</a-button>

        </div>
        <div class="operation-box">
            <a-button 
                type="primary"
                icon="plus" 
                class="btn" 
                @click="$router.push('/admin/undergraduate/culture/course/info?type=add')"
                v-if="permissions.indexOf('undergraduate:culture:course:add')>-1">
                 新增
            </a-button>
            <!-- <a-button type="primary" class="btn" icon="import"  v-if="permissions.indexOf('undergraduate:culture:course:import')>-1">批量导入</a-button>
            <a-button type="primary" class="btn" icon="download"  v-if="permissions.indexOf('undergraduate:culture:course:export')>-1">导出Excel</a-button> -->
            <a-button type="primary" class="btn" icon="book"  @click="booksInfo">教材详情</a-button>
            <a-button type="primary" class="btn" icon="plus" v-if="permissions.indexOf('undergraduate:culture:course:classroom')>-1"  @click="xzjxzl">听课评价</a-button>
            <a-button type="primary" class="btn" icon="plus" v-if="permissions.indexOf('undergraduate:culture:course:examsEarly')>-1" @click="examsEarly">提前考</a-button>
            <a-button type="primary" class="btn" icon="plus" v-if="permissions.indexOf('undergraduate:culture:course:parallelClass')>-1" @click="parallelClass">平行班考试</a-button>
            <a-button type="primary" class="btn" icon="plus" v-if="permissions.indexOf('undergraduate:culture:course:spotcheck')>-1"  @click="spotCheck">试卷抽查</a-button>
            <a-button type="primary" class="btn" icon="plus" v-if="permissions.indexOf('undergraduate:culture:course:exchange')>-1" @click="exchange">调代课</a-button>
            <a-button type="primary" class="btn" icon="edit" v-if="bkdyqx > 0" @click="courseInfo">答疑修改</a-button>
            <a-button type="primary" class="btn" icon="upload" v-if="permissions.indexOf('undergraduate:culture:course:import')>-1"  @click="importExcel">批量导入</a-button>
            <a-button type="primary" class="btn" icon="download" v-if="permissions.indexOf('undergraduate:culture:course:export')>-1" @click="exportTable">导出Excel</a-button>
            <div v-if="bkdyqx > 0"><a-tag color="red">可以修改答疑还剩{{bkdyqx}}天</a-tag></div>
        </div>
        
        <a-table
            rowKey='id'
            :customRow="onClickRow"
            :columns="columns" 
            :data-source="data" 
            :loading="loading"
            :pagination="pagination"
            @change="handleTableChange"
            :scroll="{ y: '450px' }"
            :row-selection="{ type:'radio',selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            bordered>
            courseName
            <a slot="courseName" slot-scope="text,res">
                <div style="cursor:pointer" @click="$router.push('/admin/undergraduate/culture/course/info?type=look&id='+res.id)">{{text}}</div>
            </a>
            <a slot="textBookCount" slot-scope="text,res">
                <div  style="cursor:pointer" @click="gljcClick(res.id)">{{text}}</div>
            </a>
            <a slot="examEvaluateCount" slot-scope="text">
                <div style="cursor:pointer" @click="$router.push('/admin/undergraduate/culture/classroom')">{{text}}</div>
            </a>
            <a slot="advanceExamCount" slot-scope="text">
                <div style="cursor:pointer" @click="$router.push('/admin/undergraduate/culture/examsEarly')">{{text}}</div>
            </a>
            <a slot="parallelClass" slot-scope="text">
                <div style="cursor:pointer" @click="$router.push('/admin/undergraduate/culture/parallelClass')">{{text}}</div>
            </a>
            <a slot="examScore" slot-scope="text">
                <div style="cursor:pointer" @click="$router.push('/admin/undergraduate/culture/spotcheck')">{{text}}</div>
            </a>
        </a-table>
        <gljc ref="gljc"></gljc>
    </div>
</template>
<script>
    import { getDicts } from '@/baseAPI/dictionary'
    import { list,del,exportTable } from '@/baseAPI/undergraduate/culture/course'
    import Gljc from './modules/gljc'
    import { getSchoolYear,getSemester } from '@/baseAPI/util'
    import { queryDepartmentTreeList } from '@/baseAPI/department'
    const columns = [
        {
            title: '序号',
            align:'center',
            width:50,
            // fixed: 'left',
            customRender: (text, row, index) => {
                return { children: index+1};
            },
        },
        {
            title: '课程号',
            dataIndex: 'courseId',
            // fixed: 'left',
            align:'center',
            width:100
        },
        {
            title: '课程名',
            dataIndex: 'courseName',
            // fixed: 'left',
            align:'center',
            scopedSlots: { customRender: 'courseName' },
            width:120
        },
        {
            title: '学分',
            dataIndex: 'credit',
            align:'center',
            width:40
        },
        {
            title: '教师姓名',
            dataIndex: 'teacherName',
            align:'center',
            width:80
        },
        {
            title: '教师编号',
            dataIndex: 'teacherId',
            align:'center',
            width:90
        },
        {
            title: '上课时间',
            dataIndex: 'classTime',
            align:'center',
            width:80
        },
        {
            title: '上课地点',
            dataIndex: 'classRoom',
            align:'center',
            width:80
        },
        {
            title: '教学班',
            dataIndex: 'teachClass',
            align:'center',
            width:80
        },
        // {
        //     title: '容量',
        //     dataIndex: 'studentCapacity',
        //     align:'center',
        //     width:50
        // },
        {
            title: '选课人数',
            dataIndex: 'studentNumber',
            align:'center',
            width:60
        },
        {
            title: '校区',
            dataIndex: 'campus',
            align:'center',
            width:80
        },
        {
            title: '答疑时间',
            dataIndex: 'answerTime',
            align:'center',
            width:80
        },
        {
            title: '答疑地点',
            dataIndex: 'answerRoom',
            align:'center',
            width:80
        },
        {
            title: '教学模式',
            dataIndex: 'remark',
            align:'center',
            width:80
           
        },
        // {
        //     title: '机房',
        //     dataIndex: 'computerRoom',
        //     align:'center',
        // },
        // {
        //     title: '关联教材',
        //     dataIndex: 'textBookCount',
        //     align:'center',
        //     width:60,
        //     scopedSlots: { customRender: 'textBookCount' },

        // },
        // {
        //     title: '教学质量',
        //     dataIndex: 'examEvaluateCount',
        //     align:'center',
        //     scopedSlots: { customRender: 'examEvaluateCount' },

        // },
        {
            title: '提前考',
            dataIndex: 'advanceExamCount',
            align:'center',
            width:50,
            scopedSlots: { customRender: 'advanceExamCount' },

        },
        {
            title: '平行班考试',
            dataIndex: 'parallelClass',
            align:'center',
            width:70,
            scopedSlots: { customRender: 'parallelClass' },

        },
        // {
        //     title: '试卷抽查',
        //     dataIndex: 'examScore',
        //     align:'center',
        //     scopedSlots: { customRender: 'examScore' },
        // }

    ];
    export default {
        name: 'teacher',
        components: {
            Gljc
        },
        data () {
            return {
                columns,
                data:[],
                loading: false,
                pagination:{
                    pageSize: 20,
                    current: 1,
                    total:0,
                },
                selectedRowKeys: [],
                searchFrom:{
                    size: '',
                    current: '',
                    departmentCode:'',
                    teacherName:'',
                    courseName:'',
                    schoolYear:'',
                    semester:'',
                },
                xbArr:[],
                xxArr:[],
                kclbArr:[],
                permissions:[],
                year:'',
                yearShowOne:false,
                departmentTree:[],
                bkdyArr:[],
                bkdyqx:'',
                zcArr:[],
                season:{'3':'C','4':'C','5':'C','6':'D','7':'D','8':'D','9':'A','10':'A','11':'A','12':'B','1':'B','2':'B'}
            }
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.xbArr=res.data.dicts;
            })
            getDicts({dataCode:'CAMPUS',status:true}).then(res=>{
                this.xxArr=res.data.dicts;
            })
            getDicts({dataCode:'KCLB',status:true}).then(res=>{
                this.kclbArr=res.data.dicts;
            })
            getDicts({dataCode:'ZC',status:true}).then(res=>{
                this.zcArr=res.data.dicts;
            })
            getDicts({dataCode:'BKDYSZ',status:true}).then(res=>{
                this.bkdyArr=res.data.dicts;
                console.log(this.bkdyArr[0].simpleName)
                console.log(this.bkdyArr[1].simpleName)

                if(new Date().getTime() >= new Date(this.bkdyArr[0].simpleName).getTime()){
                    let now = new Date().getTime()
                    let startDate = new Date(this.bkdyArr[0].simpleName).getTime()
                    let days = parseInt(now - startDate)/(1000 * 60 * 60 * 24)
                    this.bkdyqx = Math.ceil(parseInt(this.bkdyArr[1].simpleName) - days)
                }
            })
            this.searchFrom.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            this.year=getSchoolYear()+''
            // this.searchFrom.semester=this.year+this.season[new Date().getMonth()+1]
            this.searchFrom.semester=getSemester()
            // queryDepartmentTreeList().then(res => {
            //     this.departmentTree = res.data[0].children
            // })
            getDicts({dataCode:'XY',status:true}).then(res=>{
                this.departmentTree=res.data.dicts;
            })
            this.fetch()
        },
        methods:{
            exportTable(){
                // var obj=this.deepCopy(this.searchFrom);
                // delete obj.size;
                // delete obj.current;
                // obj.idList=this.selectedRowKeys;
                exportTable(this.searchFrom).then(res => {
                    window.open(this.$store.state.axiosUrl+'/api-f/statics/tempFileDirectory/'+res.data)
                })
            },  
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            onClickRow(record,index){
                return {
                    on: { // 事件
                        click: (event) => {
                            this.courseId=record.courseId
                            this.onSelectChange([record.id])
                        }
                    },

                }  
            },
            handleTableChange(pagination){
                this.selectedRowKeys=[];
                const pager = { ...this.pagination };
                pager.current = pagination.current;
                this.pagination = pager;
                this.fetch();
            },
            fetch() {
                this.loading = true;
                this.searchFrom.size=this.pagination.pageSize;
                this.searchFrom.current=this.pagination.current;
                list(this.searchFrom).then(res=>{
                    this.pagination.total = res.data.total;
                    this.data = res.data.records;

                    this.data.forEach(e=>{
                        if(e.textBookCount > 0){
                            e.textBookCount = '是'
                        }else{
                            e.textBookCount = '-'
                        }
                        if(e.examEvaluateCount > 0){
                            
                        }else{
                            e.examEvaluateCount ='-'
                        }
                        if(e.advanceExamCount > 0){
                            e.advanceExamCount = '是'
                        }else{
                            e.advanceExamCount = '-'
                        }
                        if(e.parallelClass=='commit'){
                            e.parallelClass = '已提交'
                        }else if(e.parallelClass=='reject'){
                            e.parallelClass = '已驳回'
                        }else if(e.parallelClass=='approved'){
                            e.parallelClass = '系主任已审批'
                        }else if(e.parallelClass == null ||e.parallelClass == ''){
                            e.parallelClass = '-'
                        }
                        if(e.examScore != null){
                            
                        }else{
                            e.examScore ='-'
                        }
                    })
                    this.loading = false;
                })
            },
            searchList(){
                this.pagination.current=1;
                this.fetch()
            },
            remove(id){
                del(id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程表成功',
                        });
                        this.fetch()
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.searchFrom.schoolYear=this.year+'-'+(this.year-0+1);
                this.searchFrom.semester='';
                this.yearShowOne = false;
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
                console.log(selectedRowKeys)
            },
            gljcClick(id){
                if(id != '' && id !=null && typeof id === "string"){
                    this.$refs.gljc.showModal(id,'gl')
                }else if(this.selectedRowKeys.length>0){
                    this.$refs.gljc.showModal(this.selectedRowKeys[0],'gl')
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再关联教材',
                    });
                }
            },
            xzjxzl(){
                if(this.selectedRowKeys.length>0){
                    let row
                    this.data.forEach((item)=>{
                        if(item.id == this.selectedRowKeys[0]){
                            row = item
                        }
                    })
                    this.$router.push('/admin/undergraduate/quality/classroom/info?type=add&courseId='+this.selectedRowKeys[0]+'&semester='+row.semester)
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再关联教材',
                    });
                }
            },
            examsEarly(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/examsearly/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行提前考',
                    });
                }
            },
            parallelClass(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/parallelClass/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行平行班考试',
                    });
                }
            },
            spotCheck(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/quality/spotcheck/info?type=add&courseId='+this.selectedRowKeys[0]+'&kch='+this.courseId)
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行试卷抽查',
                    });
                }
            },
            exchange(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/exchange/info?type=add&courseId='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行调代课',
                    });
                }
            },
            courseInfo(){
                if(this.selectedRowKeys.length>0){
                    this.$router.push('/admin/undergraduate/culture/course/info?type=answer&id='+this.selectedRowKeys[0])
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再进行答疑修改',
                    });
                }
            },
            booksInfo(){
                if(this.selectedRowKeys.length>0){
                    let row
                    this.data.forEach((item)=>{
                        if(item.id == this.selectedRowKeys[0]){
                            row = item
                            if(item.classTime.indexOf('全英语') > 0){
                                row['languageName'] = '英文'
                            }else{
                                row['languageName'] = '中文'
                            }
                        }
                    })
                    this.$router.push('/admin/undergraduate/culture/books/info?type=look&courseId='+row.courseId+'&semester='+row.semester+'&languageName='+row.languageName)
                }else{
                    this.$notification['info']({
                        message: '提示',
                        description:'请选择课程后再查看教材',
                    });
                }
            }
        }
    }
</script>
<style scoped>
    >>> .ant-table-thead > tr > th {
        padding: 5px !important;
    }

    >>> .ant-table-tbody > tr > td {
        padding: 5px !important;
    }

    .search-box
    {
        padding-bottom: 24px;
        border-bottom: 1px solid rgba(151,151,151,0.60);
        margin-bottom: 10px;
    }
    
    .search-box p
    {
        display: inline-block;
    }
    .search-box .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box .input-box{
        margin-right: 1rem;
        width: 10rem;
    }

    .search-box-1
    {
        margin-bottom: 10px;
    }

    .search-box-1 p
    {
        display: inline-block;
    }
    .search-box-1 .right-btn
    {
        float: right;
        margin-left: 1rem;
    }
    .search-box-1 .input-box{
        margin-right: 1rem;
        width: 10rem;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 14px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper .show-input{
        height: 23px;
        line-height: 23px;
    }
    .ant-table-wrapper .show-input >>> .ant-select-selection{
        background-color: transparent;
        border: none;
        color: rgba(0, 0, 0, 0.65);
    }
    .ant-table-wrapper .show-input >>> .ant-select-arrow{
        display: none;
    }
    .ant-dropdown-link{
        display: inline-block;
        font-size: 0.9rem;
    }
    .operation-box{
        display: flex;
        margin-bottom: 10px;
    }

    .operation-box .btn{
        margin-right: 1rem;
    }
</style>
